// Web shim for react-native-fs
// Provides fallback for file system operations on web

const RNFS = {
  // File system path constants
  MainBundlePath: '',
  CachesDirectoryPath: '/caches',
  DocumentDirectoryPath: '/documents',
  ExternalDirectoryPath: '/external',
  ExternalStorageDirectoryPath: '/storage',
  TemporaryDirectoryPath: '/temp',
  
  readFile: async (filePath: string, encoding = 'utf8'): Promise<string> => {
    console.warn('RNFS.readFile not supported on web');
    return '';
  },
  
  readFileAssets: async (filePath: string, encoding = 'utf8'): Promise<string> => {
    console.warn('RNFS.readFileAssets not supported on web');
    return '';
  },
  
  readdir: async (dirPath: string): Promise<string[]> => {
    console.warn('RNFS.readdir not supported on web');
    return [];
  },
  
  stat: async (filePath: string): Promise<any> => {
    console.warn('RNFS.stat not supported on web');
    return { size: 0, isFile: () => false, isDirectory: () => false };
  },
  
  exists: async (filePath: string): Promise<boolean> => {
    console.warn('RNFS.exists not supported on web');
    return false;
  },
  
  writeFile: async (filePath: string, contents: string, encoding = 'utf8'): Promise<void> => {
    console.warn('RNFS.writeFile not supported on web');
  },
  
  deleteFile: async (filePath: string): Promise<void> => {
    console.warn('RNFS.deleteFile not supported on web');
  },
  
  mkdir: async (dirPath: string): Promise<void> => {
    console.warn('RNFS.mkdir not supported on web');
  },
  
  downloadFile: async (options: any): Promise<any> => {
    console.warn('RNFS.downloadFile not supported on web');
    return { jobId: -1 };
  },
};

export default RNFS;
